import { render } from "./company.vue?vue&type=template&id=d0fed416&scoped=true"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"

import "./company.vue?vue&type=style&index=0&id=d0fed416&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d0fed416"

export default script